import Box from "@amzn/meridian/esm/components/box";
import Input from "@amzn/meridian/esm/components/input";
import Row from "@amzn/meridian/esm/components/row";
import checkLargeTokens from "@amzn/meridian-tokens/base/icon/check-large";
import undoTokens from "@amzn/meridian-tokens/base/icon/undo";
import IconButton from "../IconButton";
import { LABEL_ROW_WIDTHS, ACTION_SLOT_WIDTH, ROW_LINE_HEIGHT, EDITABLE_ROW_HEIGHT } from "./agenda.constants";
import { editRowOffsetClass } from "./agenda.styles";

/**
 * AgendaEditInput - Shared inline text-entry row used by both the add and edit states:
 * an Input plus commit (check) / cancel (undo) buttons, so the two call sites only supply
 * the varying pieces.
 */
const AgendaEditInput = ({ value, onChange, onKeyDown, onFocus, placeholder, commitLabel, onCommit, onCancel, spacingInset }) => (
  <div className={editRowOffsetClass}>
    <Row
      width="100%"
      minHeight={EDITABLE_ROW_HEIGHT}
      widths={LABEL_ROW_WIDTHS}
      spacing="200"
      alignmentVertical="center"
      spacingInset={spacingInset}
    >
      {/* minWidth 0 lets the input shrink below its intrinsic width in the narrow panel. */}
      <Box minWidth={0}>
        <Input
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          placeholder={placeholder}
          width="100%"
          size="small"
          inaccessibleAutoFocus
        />
      </Box>
      <Row width={ACTION_SLOT_WIDTH} height={ROW_LINE_HEIGHT} spacing="200" alignmentVertical="center" alignmentHorizontal="end">
        <IconButton icon={checkLargeTokens} onClick={onCommit} ariaLabel={commitLabel} />
        <IconButton icon={undoTokens} onClick={onCancel} ariaLabel="Cancel" />
      </Row>
    </Row>
  </div>
);

export default AgendaEditInput;
